import React, { useState, useEffect, useRef } from 'react';
import { Redirect, Link } from 'react-router-dom';

import 'react-accessible-accordion/dist/fancy-example.css';
import Loader from '../../Loader/Loader';

import { reqGET } from '../../../Utils';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from './../../../UseToken';
import { language } from './Language';
import { color } from '../../WEBContent/Color';

import Intranet_PurchaseOrder from '../../Intranet/PurchaseOrder/Init'

export default function View(props) {

    const [dados, set_dados] = useState(data_interface);
    const [lang, set_lang] = useState('pt');
    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);
    const [isEdit, setisEdit] = useState(false);
    const [editedData, setEditedData] = useState(dados);
    const [idEntidade, setIdEntidade] = useState('')
    const [temporada_atual, set_temporada_atual] = useState('')

	let year = new Date().getFullYear();

	const ESCALOES_GERAL = [
		{ id: 'U10', label: 'U10', min: (parseInt(year) - 9), max: Infinity },
		{ id: 'U12', label: 'U12', min: (parseInt(year) - 11), max: (parseInt(year) - 10) },
		{ id: 'U14', label: 'U14', min: (parseInt(year) - 13), max: (parseInt(year) - 12) },
		{ id: 'U16', label: 'U16', min: (parseInt(year) - 15), max: (parseInt(year) - 14) },
		{ id: 'U18', label: 'U18', min: (parseInt(year) - 17), max: (parseInt(year) - 16) },
		{ id: 'U21', label: 'U21', min: (parseInt(year) - 20), max: (parseInt(year) - 17) },
		{ id: 'SENIOR', label: 'Sénior', min: (parseInt(year) - 34), max: (parseInt(year) - 21) },
		{ id: 'M35', label: 'M35', min: (parseInt(year) - 54), max: (parseInt(year) - 35) },
		{ id: 'M55', label: 'M55', min: -Infinity, max: (parseInt(year) - 55) },
	];

	const ESCALOES_SNOWBOARD = [
		{ id: 'U9', label: 'U9 (kids)', min: (parseInt(year) - 8), max: Infinity },
		{ id: 'U11', label: 'U11 (SuperGrom)', min: (parseInt(year) - 10), max: (parseInt(year) - 9) },
		{ id: 'U13', label: 'U13 (SuperGrom)', min: (parseInt(year) - 12), max: (parseInt(year) - 11) },
		{ id: 'U15', label: 'U15 (Grom)', min: (parseInt(year) - 14), max: (parseInt(year) - 13) },
		{ id: 'U18_ROOKIE', label: 'U18 (Rookie)', min: (parseInt(year) - 17), max: (parseInt(year) - 15) },
		{ id: 'ABSOLUTO', label: 'Absoluto', min: (parseInt(year) - 42), max: (parseInt(year) - 18) },
		{ id: 'M40', label: 'M40 (Master)', min: -Infinity, max: (parseInt(year) - 43) },
	];

	const ESCALOES_PATINAGEM = [
		{ id: 'PRE_INICIADO', label: 'Pré-Iniciado' },
		{ id: 'NOVATOS', label: 'Novatos' },
		{ id: 'JUNIORES', label: 'Juniores' },
		{ id: 'SENIORES', label: 'Seniores' },
		{ id: 'ADULTOS', label: 'Adultos' },
	];

	const OPCOES_ESCALAO = {
		geral: ESCALOES_GERAL,
		snowboard: ESCALOES_SNOWBOARD,
		patinagem: ESCALOES_PATINAGEM,
	};

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '14px',
        color: color.cor1.hexa,
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        overflow: 'hidden',
        backgroundColor: color.cor3.hexa,
        marginBottom: '20px',
    };

    const headerCellStyle = {
        padding: '12px 15px',
        textAlign: 'center',
        color: color.cor3.hexa,
        fontWeight: '600',
        borderBottom: '2px solid #ddd',
        backgroundColor: color.cor2.rgb,
        textTransform: 'uppercase',
    };

    const cellStyle = {
        borderBottom: `1px solid rgb(${color.cor3.rgb})`,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '12px 15px',
        color: color.corCinza.hexa,
        lineHeight: '1.6',
        backgroundColor: color.cor3.hexa,
    };

    const tarefasCellStyle = {
        ...cellStyle,
        textAlign: 'left',
        fontWeight: '500',
    };

    const rowStyle = {
        backgroundColor: color.cor3.hexa,
        transition: 'background-color 0.3s ease',
        //cursor: 'pointer',
    };

	const anoNascimento = (birthday) => {
		if (!birthday) return null;
		const ano = parseInt(String(birthday).slice(0, 4), 10);
		return Number.isNaN(ano) ? null : ano;
	};

	const escalaoPorAno = (ano, tabela) => {
		if (ano === null) return '';
		const item = tabela.find(e => ano >= e.min && ano <= e.max);
		return item ? item.id : '';
	};

	// Idade de referência = idade que o atleta tem a 1 de julho do ano em que a época começa
	const idadeReferencia = (birthday, anoEpoca) => {
		if (!birthday) return null;
		const nascimento = new Date(birthday);
		const referencia = new Date(anoEpoca, 6, 1); // 1 de julho
		let idade = referencia.getFullYear() - nascimento.getFullYear();
		const diffMes = referencia.getMonth() - nascimento.getMonth();
		if (diffMes < 0 || (diffMes === 0 && referencia.getDate() < nascimento.getDate())) idade--;
		return idade;
	};

	// Faixas sobrepostas (Novatos/Juniores/Seniores) -> prioridade: mais "novo" primeiro
	const escalaoPorIdade = (idade) => {
		if (idade === null) return '';
		if (idade >= 28) return 'ADULTOS';
		if (idade > 13 && idade <= 18) return 'JUNIORES';
		if (idade >= 8 && idade <= 13) return 'NOVATOS';
		if (idade >= 17) return 'SENIORES';
		if (idade >= 6) return 'PRE_INICIADO';
		return '';
	};

	const detectarGrupoModalidade = (modalidades) => {
		if (!Array.isArray(modalidades) || modalidades.length === 0) 
			return 'geral';
		
		const valores = modalidades.map(m => (m.id ?? m.name ?? m ?? '').toString().toLowerCase());
		
		if (valores.some(v => v.includes('patinagem'))) 
			return 'patinagem';
		if (valores.some(v => v.includes('snowboard'))) 
			return 'snowboard';
		
		return 'geral';
	};

	const calcularEscalao = (birthday, modalidades, anoEpoca) => {

		console.log('birthday', birthday)
		console.log('modalidades', modalidades)
		console.log('anoEpoca', anoEpoca)

		const grupo = detectarGrupoModalidade(modalidades);
		console.log('grupo', grupo)
		if (grupo === 'patinagem') {
			return escalaoPorIdade(idadeReferencia(birthday, anoEpoca));
		}
		const tabela = grupo === 'snowboard' ? ESCALOES_SNOWBOARD : ESCALOES_GERAL;
		return escalaoPorAno(anoNascimento(birthday), tabela);
	};

    const getAnoEpocaAtual = () => {
		const hoje = new Date();
		const anoAtual = hoje.getFullYear();
		const mesAtual = hoje.getMonth(); // 0 = janeiro, 6 = julho

		// Época muda em julho (mês índice 6)
		return mesAtual >= 6 ? anoAtual : anoAtual - 1;
	};

    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {

        let temporada_ativa = ''
        let temporada_aux = await reqGET(`${api_crud_base}/intranet/components/type/${getTokenInfo().companycode}/temporada`)
        if(Array.isArray(temporada_aux.data)) {
            let t_aux = temporada_aux.data.find(e => e.info.active)
            temporada_ativa = t_aux;
            set_temporada_atual(t_aux)
        }

        console.log("id da entidade que tamos a editar", id)
        setIdEntidade(id)
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(res => {

		        const anoEpoca = getAnoEpocaAtual();
            
                const sugestao = calcularEscalao(
                    res.data[0].info.birthday,
                    res.data[0].info.modalidades,
                    temporada_ativa.info.name
                );

                console.log('sugestao', sugestao)
                res.data[0].info.escalao = sugestao
                
                set_dados(res.data[0])

            })
            .catch(() => 404
                //  TODO: ENVIAR PÃ�GINA 404
                //  alert(error)); 
            );
    }

    const change_lang = (l) => {
        set_lang(l)
        window.location.reload()

        //console.log('language', localStorage.getItem('lang'))
        //console.log('localstorage', localStorage)
    }

    useEffect(() => {

        //set_lang('pt')
        //set_lang_id('1')

        //get_fact_legacy_info()
        //get_fact_legacy_info()

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            change_lang('pt')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            console.log("estamos a alterar para", lang)
        }

        setLoading(false)

    }, [props])

    useEffect(() => {

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);


    const toggleEditMode = () => {
        setisEdit(!isEdit);
        setEditedData(dados); // Reseta os dados editados caso cancele a edição
    };

    const formatPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return '';

        // Remove qualquer caractere não numérico
        const cleaned = phoneNumber.replace(/\D/g, '');


        if (cleaned.length < 9) return phoneNumber;


        const countryCode = cleaned.slice(0, 3); // Exemplo: 351

        const phoneNumberWithoutCode = cleaned.slice(3);


        const formattedPhone = phoneNumberWithoutCode.replace(/(\d{3})(?=\d)/g, '$1 ');


        return `+${countryCode} ${formattedPhone}`;
    };

    console.log('DADOS DA ENTIDADE: ', dados)

    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?

            <Loader />

            :

            <div className="content d-flex flex-column flex-column-fluid">
                <div className="card-body border-top p-4">
                    <div className="row mb-4">
                        <div className="col-md-6 p-4 bg-white shadow-sm" style={{ borderRadius: "8px" }}>
                            <div className="d-flex flex-column align-items-center">
                                {
                                dados.info?.foto?.[0]?.link ?
                                    <div className='position-relative'>
                                        <img
                                            src={dados.info.foto[0].link}
                                            alt="Profile"
                                            style={{ width: "96px", height: "96px", borderRadius: "50%" }}
                                            className="mb-3"
                                        />
                                        {
                                        Array.isArray(dados.info.inscricao) && dados.info.inscricao.length > 0 ?
                                            <span class={"position-absolute top-0 start-100 translate-middle badge rounded-pill px-3 py-2 ms-3 bg-" + (parseInt(dados.info.inscricao.slice(-1)[0].temporada.id) === parseInt(temporada_atual.id) ? "success" : 'secondary')}>
                                                {dados.info.inscricao.slice(-1)[0].temporada.name}
                                            </span>
                                        :
                                            null
                                        }
                                    </div>
                                : 
                                    <i className="bi bi-people-fill mb-3" style={{ fontSize: "96px", color: color.corCinza.rgb }}></i>
                                }
                                <h2 className="h5 fw-bold mb-1">{dados.info?.name || 'N/A'}</h2>
                                <p className="text-muted">
                                    {
                                    dados.info?.attributes !== undefined && Array.isArray(dados.info?.attributes?.entity_profile) && dados.info?.attributes?.entity_profile.length > 0 ? 
                                        (
                                        dados.info.attributes.entity_profile[0]?.name !== undefined ? 
                                            dados.info.attributes.entity_profile[0].name 
                                        : 
                                            dados.info.attributes.entity_profile[0].label
                                        ) 
                                    : 
                                        null
                                    }
                                    </p>
                            </div>
                        </div>

                        <div className="col-md-6 p-4 bg-white shadow-sm" style={{ borderRadius: "8px" }}>
                            <div className="row gy-3">
                                <div className="col-12">
                                    <label className="form-label text-muted">{language[lang].email}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.contacts?.[0]?.email || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-12">
                                    <label className="form-label text-muted">{language[lang].tlf}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.contacts?.[0]?.mobile_phone || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-12">
                                    <label className="form-label text-muted">{language[lang].numero_licenca}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.info.numero_licenca}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-4">
                        <div className="col-md-12 p-4 bg-white shadow-sm" style={{ borderRadius: "8px" }}>
                            <h3 className="h5 fw-bold mb-4">{language[lang].detalhes_utilizador}</h3>

                            <div className="row gy-3 mb-3">
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].birthday}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.info?.birthday || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].estado_civil}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {
                                            dados.info.estado_civil == 0
                                                ? language[lang].solteiro
                                                : dados.info.estado_civil == 1
                                                    ? language[lang].casado
                                                    : dados.info.estado_civil == 2
                                                        ? language[lang].dicorciado
                                                        : dados.info.estado_civil == 3
                                                            ? language[lang].viuvo
                                                                : 'N/A'
                                        }
                                    </p>
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].habilitacao_literaria}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {
                                            dados.info.habilitacao_literaria == 0
                                                ? language[lang].ensino_basico
                                                : dados.info.habilitacao_literaria == 1
                                                    ? language[lang].ensino_secundario
                                                    : dados.info.habilitacao_literaria == 2
                                                        ? language[lang].licenciatura
                                                        : dados.info.habilitacao_literaria == 3
                                                            ? language[lang].mestrado
                                                            : dados.info.habilitacao_literaria == 4
                                                                ? language[lang].doutoramento
                                                                : dados.info.habilitacao_literaria == 5
                                                                    ? language[lang].pos_doutoramento
                                                                    : 'N/A'
                                        }
                                    </p>
                                </div>
                            </div>

                            <div className="row gy-3 mb-3">
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].country}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.country || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].district}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.region || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].city}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.city || 'N/A'}
                                    </p>
                                </div>
                            </div>
                            
                            <div className="row gy-3 mb-3">
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].village}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.village || 'N/A'}
                                    </p>
                                </div>                                
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].morada}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.address_detail || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].postal_code}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.postal_code || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].local}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.localidade || 'N/A'}
                                    </p>
                                </div>

                                                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].tipo_identificacao}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {
                                            dados.info?.identificacao?.tipo_identificacao === 'cc'
                                                ? language[lang].cc
                                                : dados.info?.identificacao?.tipo_identificacao === 'bi'
                                                    ? language[lang].bi
                                                    : dados.info?.identificacao?.tipo_identificacao === 'ar'
                                                        ? language[lang].autorizacao_residencia
                                                        : dados.info?.identificacao?.tipo_identificacao === 'passaporte'
                                                            ? language[lang].passaporte
                                                                : 'N/A'
                                        }
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].numero_identificacao}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.info?.identificacao?.numero_identificacao || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].validade_identificacao}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.info?.identificacao?.validade_identificacao || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].vat}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.info?.vat || 'N/A'}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="row mb-5">
                        <div className="col-md-12 p-4 bg-white shadow-sm" style={{ borderRadius: "8px" }}>
                            <h3 className="h5 fw-bold mb-4">{language[lang].dados_desportivos}</h3>

                            <div className="row gy-3 mb-3">
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].numero_licenca}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.info.numero_licenca}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].genero}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.info.genero == 2
                                            ? language[lang].feminino
                                            : dados.info.genero == 1
                                                ? language[lang].masculino
                                                : dados.info.genero == 0
                                                    ? language[lang].outro
                                                    : 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].escalao}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.info?.escalao || 'N/A'}
                                    </p>
                                </div>
                            </div>

                            <div className="row gy-3 mb-3">
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].function}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {
                                        dados.info.attributes !== undefined && Array.isArray(dados.info.attributes.entity_profile) ? 
                                            dados.info.attributes.entity_profile.map(c => c.name !== undefined ? c.name.trim() + '; ' : c.label.trim() + '; ')
                                        : 
                                            'N/A'
                                        }
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].clube}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {Array.isArray(dados.info?.clube) && dados.info.clube.length > 0 && dados.info?.clube[0].name !== '' ? dados.info.clube[0].name : 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].modalidades}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {
                                        Array.isArray(dados?.info?.modalidades) && dados.info.modalidades.length > 0 ?
                                            dados.info.modalidades.map((el_m, k_m) => <span key={k_m}>{language[lang][el_m.id]};</span>)
                                        :
                                            'N/A'
                                        }
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].outras_modalidades}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {
                                        Array.isArray(dados?.info?.outras_modalidades) && dados.info.outras_modalidades.length > 0 ?
                                            dados.info.outras_modalidades.map((el_m, k_m) => <span key={k_m}>{language[lang][el_m.id]}; </span>)
                                        :
                                            'N/A'
                                        }
                                    </p>
                                </div>
                            </div>
                            
                            <div className="row gy-3 mb-3">
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].exames_medicos}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {
                                        Array.isArray(dados?.info?.exame_medico) && dados.info.exame_medico.length > 0 ?
                                            <a href={dados.info.exame_medico[0].link} target="_blank">{dados.info.exame_medico[0].name} <i className="bi bi-box-arrow-up-right ms-2"></i></a>
                                        :
                                            'N/A'
                                        }
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].data_exame_medico}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.info?.data_emissao_exame_medico || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].seguro_opcional}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {
                                        dados.info?.seguro_opcional !== undefined ? 
                                            parseInt(dados.info.seguro_opcional) === 1 ?
                                                'Sim'
                                            :
                                            parseInt(dados.info.seguro_opcional) === 0 ?
                                                'Não'
                                            :
                                                'N/A'
                                        :
                                            'N/A'
                                        }
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="row mb-4">
                        <div className="col">
                            {Array.isArray(dados.info?.departamento) && dados.info.departamento.length > 0 && (
                                <div className={"div-table"}>
                                    <h3 className="h5 fw-bold mb-4">{language[lang].departamentosEntidade}</h3>
                                    <table className="table interlocutores-list table-hover table-bordered align-middle">
                                        <thead className="text-center align-middle">
                                            <tr>
                                                <th className='p-3'>{language[lang].departamento}</th>
                                                <th className='p-3'>{language[lang].funcoes}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dados.info.departamento.map((departamento) => (
                                                <tr key={departamento.id} style={rowStyle}>
                                                    <td>{departamento.name}</td>
                                                    <td>{departamento.software?.map((software, index) => (
                                                            <span key={software.id}>
                                                                {software.nome}
                                                                {index < departamento.software.length - 1 ? ", " : ""}
                                                            </span>
                                                        ))}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className={'dash-cards footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            
                            <ul className="navbar-nav float-right">
                                {
                                getTokenInfo().profile === 'Cliente' ?
                                    null
                                :
                                    <li className={(getTokenInfo().profile === 'Cliente') ? 'd-none' : "nav-item d-none" + ' ' + getTokenInfo().profile}>
                                        <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                            <i className="bi bi-chevron-left me-2"></i>
                                            <span>{language[lang].back}</span>
                                        </Link>
                                    </li>
                                }

                                {
                                getTokenInfo().profile === 'Cliente' ?
                                    null
                                :
                                    <li className={(getTokenInfo().profile === 'Cliente') ? 'd-none' : "nav-item"}>
                                        <Link className="nav-link btn-cancel" to={{ pathname: (props.location.state !== null && props.location.state.go_back_operation === 'store_order_list' ? Intranet_PurchaseOrder.list.endpoint : endpoints.list), state: { temporada: (props.location.state !== null ? props.location.state.temporada : '') } } }  >
                                            <i className="bi bi-chevron-left me-2"></i>
                                            <span>{language[lang].back}</span>
                                        </Link>
                                    </li>
                                }


                                <li className="nav-item">
                                    <button onClick={toggleEditMode} className="nav-link text-white">
                                        <Link to={{ state: { item: { id: idEntidade }, operation: 'edit' }, pathname: endpoints.regist }}>
                                            <i className="bi bi-pencil me-2 text-white"></i>
                                            <span className="text-white">{language[lang].edit}</span>
                                        </Link>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>

}